"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var monitoring_1 = require("../../services/monitoring");
var StatusIndicator_1 = require("../StatusIndicator/StatusIndicator");
var getHexColor_1 = require("../../services/getHexColor");
var Icon_1 = require("../Icon/Icon");
var FullPageAlert = /** @class */ (function (_super) {
    __extends(FullPageAlert, _super);
    function FullPageAlert(props) {
        return _super.call(this, props) || this;
    }
    FullPageAlert.prototype.componentDidMount = function () {
        monitoring_1.default('fullPageAlert');
    };
    FullPageAlert.prototype.render = function () {
        var _a = this.props, title = _a.title, icon = _a.icon, description = _a.description, buttons = _a.buttons, colorString = _a.color, className = _a.className, style = _a.style;
        var classes = classNames('alert--full-page', className);
        var color = getHexColor_1.default(colorString);
        return (React.createElement("div", { className: classes, style: style },
            icon ? (React.createElement(Icon_1.default, { icon: icon, size: "8x", color: color })) : (React.createElement(StatusIndicator_1.default, { color: color, size: "110px" })),
            React.createElement("div", { className: "alert__text-container" },
                React.createElement("h1", { className: "alert__title" }, title),
                React.createElement("h4", { className: "alert__description" }, description)),
            React.createElement("div", { className: "alert__buttons" }, buttons)));
    };
    return FullPageAlert;
}(React.Component));
exports.default = FullPageAlert;
//# sourceMappingURL=FullPageAlert.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/FullPageAlert/FullPageAlert.js
// module id = 252
// module chunks = 0